import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { ICardBoardNameHOCProps } from './types';
import { CardBoardName } from '../../components/CardBoardName/CardBoardName';
import { ICardBoardNameEvents, ICardBoardNameFields } from '../../components/CardBoardName/types';
import { onClick } from './events/onClick';
import { getBoard } from '../../../../../../../store/model/selectors/getBoardById';
import { getActiveBoardId } from '../../../../../../../store/model/selectors/getActiveBoardId';
import { IS_SHOWED_CARD_BOARD_NAME_ANIMATION_SESSIONSTORAGE } from '../../components/CardBoardName/constants';
import { getIsAssignedToMeActive } from '../../../../../../../store/router/selectors/getIsAssignedToMeActive';

const mapStateToProps = (
    state: IApplicationState,
    { boardId, cardId }: ICardBoardNameHOCProps
): ICardBoardNameFields => {
    const activeBoardId = getActiveBoardId(state);
    let isShowAnimation = !getIsAssignedToMeActive(state);
    if (isShowAnimation) {
        let data = sessionStorage.getItem(IS_SHOWED_CARD_BOARD_NAME_ANIMATION_SESSIONSTORAGE);
        data = data ? JSON.parse(data) : {};
        if (data[cardId]) {
            isShowAnimation = false;
        }
    }
    return {
        boardName: getBoard(state, boardId).name,
        isShow: activeBoardId !== boardId,
        isShowAnimation,
    }
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId }: ICardBoardNameHOCProps
): ICardBoardNameEvents => {
    return {
        onClick: () => dispatch(onClick(cardId)),
    }
};

export const CardBoardNameHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardBoardName);

CardBoardNameHOC.displayName = 'CardBoardNameHOC';
